import { useCradSize } from "@/hooks/use-card-size";
import { CreateAudioButton } from "@/components/common/create-audio-button";
import { VoiceCard } from "@/components/assets-voice/voice-card";
import { assetsVoiceHooks } from "@/manager";
import { useTranslation } from "react-i18next";

// 骨架屏容器组件
function Skeleton() {
  return Array.from({ length: 40 }).map((_, index) => (
    <div key={index} className="w-full h-18 rounded-sm animate-pulse">
      <div className="w-full h-18 bg-gray-300 rounded-sm mb-4"></div>
    </div>
  ));
}

/** 配音列表页 */
export const AssetsVoice = () => {
  const { t } = useTranslation();
  const { voices, loading } = assetsVoiceHooks.useData();
  const { renameVoice } = assetsVoiceHooks.useRename();
  const { addVoice } = assetsVoiceHooks.useAdd();
  const { ref, columns } = useCradSize({
    min: 260,
    max: 400,
    gap: 16,
    aspectRatio: 76 / 316,
    resizeObserverListen: true,
  });

  const handleRename = async (audio: Audio, name: string) => {
    await renameVoice({ audio, name });
  }

  return (
    <div className="relative bg-white p-8 pt-3 h-full w-full overflow-hidden">
      <header className="mb-[18px] z-[50]">
        <div className="text-[20px] font-bold">{t('assets.voice')}</div>
      </header>
      <div className="h-full overflow-y-auto">
        <div
          ref={ref}
          className="grid gap-4 w-full mb-5"
          style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
        >
          {loading && <Skeleton />}
          {!loading && (
            <>
              <CreateAudioButton onSubmit={addVoice} />
              {voices.map((item, index) => (
                <VoiceCard key={`${item.id}_${index}`} audio={item} onRename={(name) => handleRename(item, name)} />
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
